module.exports = __webpack_public_path__ + "static/media/Dollar Sign.f55b4332.svg";